import api from '../services/api';
import { IClient } from '../shared/interfaces';

interface IResponseGetClients {
  data: IClient[];
  count: number;
}

export const getClients = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetClients> => {
  const response = await api.post('/clients/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const getClient = async (id: string | undefined): Promise<IClient> => {
  if (!id) {
    throw new Error('ID do cliente não fornecido.');
  }
  const response = await api.get(`/clients/${id}`);
  return response.data;
};

export const postClient = async (payload: any): Promise<IClient> => {
  const response = await api.post(`/clients`, payload);
  return response.data;
};

export const patchClients = async (
  id: string | undefined,
  payload: any,
): Promise<IClient> => {
  if (!id) {
    throw new Error('ID do cliente não fornecido.');
  }
  const response = await api.patch(`/clients/${id}`, payload);
  return response.data;
};

export const getSelectClients = async (param: number): Promise<IClient[]> => {
  const response = await api.get(`/clients/select/${param}`);
  return response.data;
};
